import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "../-errorComponent";
import {NotFoundComponent} from "../-notFoundComponent";
import {PendingComponent} from "../-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {getAllAuthenticationSessionsWithCaching} from "../-queries";

export {AUTHENTICATION_ALL_SESSIONS_QUERY_KEY} from "../-queries";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/authentication/sessions",
)({
    loader: async ({context}) => {
        const sessions = await getAllAuthenticationSessionsWithCaching({
            queryClient: context.queryClient,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        });

        return {
            sessions,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
